<template>
  <div class="form-group">
    <div
      class="form-label">
      <label class="control-label">
        第三者の権利物情報
        <span class="req">＊</span>
      </label>
      <i
        v-tooltip="spTooltipConfig(tooltipMessages.rightsdocument)"
        class="sp-tooltip-icon">
      </i>
      <i
        v-tooltip="pcTooltipConfig(tooltipMessages.rightsdocument)"
        class="tooltip-icon">
      </i>
    </div>
    <div class="form-item">
      <div>
        <div>
          <div
            class="form-label"
            style="margin-top:1em;">
            <label class="control-label">
              第三者の権利物の使用について
              <span class="req">＊</span>
            </label>
          </div>
        </div>
        <div class="form-item-inline">
          <span class="radio">
            <label for="rightsFlag">
              <input
                id="rightsFlag"
                v-model="rightsFlag"
                type="radio"
                name="rightsFlag"
                value="1"
                @change="onRightsFlagChange">
              <div class="option-input"></div> 使用している
            </label>
          </span>
          <span class="radio">
            <label for="not_rightsFlag">
              <input
                id="not_rightsFlag"
                v-model="rightsFlag"
                type="radio"
                name="rightsFlag"
                value="0"
                @change="onRightsFlagChange">
              <div class="option-input"></div> 使用していない
            </label>
          </span>
        </div>
        <p
          v-if="errors.use_rights"
          class="error-text">
          {{ errors.use_rights[0] }}
        </p>
      </div>
      <div>
        <div
          class="form-item-text"
          style="margin-top:1em;">
          第三者が権利を有する楽曲や素材等を使った楽曲を配信する場合、権利者から商用利用の許諾を得る必要があります。<br>
          許諾の証明として、1つ以上の権利物情報を追加してください。
          <router-link
            :to="{ name : 'faq-detail', params: {id: 206} }"
            class="c-text-link"
            target="_blank">
            詳細はこちら
          </router-link>
        </div>
      </div>
      <div v-if="rightsFlag==='1'">
        <div>
          <div
            v-for="(doc,docNum) in value"
            :key="JSON.stringify(doc)"
            :class="{'card-item':true,'card-top-line': docNum !== 0}">
            <div>
              <div
                class="form-label"
                style="margin-top:1em;">
                <label class="control-label">
                  権利物の種類
                  <span class="req">＊</span>
                </label>
              </div>
            </div>
            <div>
              <div
                class="c-select_wrap pcw-60"
                style="margin-top:1em;">
                <select
                  v-model.lazy="doc.type"
                  class="form-control c-select"
                  style="width:100%;"
                  @change="typeChange(docNum)">
                  <option
                    v-for="{id,label} in selectableTypes(doc.type)"
                    :key="id"
                    :value="id">
                    {{ label }}
                  </option>
                </select>
              </div>
              <div>
                <p
                  v-if="errors[`rights_documents.${docNum}.type`]"
                  class="error-text">
                  {{ errors[`rights_documents.${docNum}.type`].join('') }}
                </p>
              </div>
            </div>

            <div>
              <div
                class="form-label"
                style="margin-top:1em;">
                <label class="control-label">
                  許諾の証明となるファイルやURLを追加
                  <span class="req">＊</span>
                </label>
              </div>
            </div>
            <div>
              <div cols="12">
                <div
                  class="checkbox"
                  style="display:block;margin-top:0.5em">
                  <label>
                    <input
                      type="checkbox"
                      :checked="doc.showImages"
                      @click="onClickImages(docNum)">
                    <div
                      class="option-input">
                    </div>
                    ファイルをアップロード（JPEG, PNG, PDF）
                  </label>
                </div>
              </div>
            </div>
            <div>
              <div v-if="doc.showImages">
                <div
                  v-for="(image,index) in doc.images"
                  :key="image.path">
                  <div
                    style="margin-top:0.5em;">
                    <a
                      :class="`${[docNum,index].join('-')} c-btn
                      c-btn--download--narrow ${!image.name?'':'c-btn--change'} spw-90`"
                      @click.prevent="onFileSelectClicked">
                      {{ !image.name?'ファイルを選択':'変更する' }}
                    </a>
                    {{ image.name }}
                    <button
                      type="button"
                      class="c-btn c-btn--narrow c-btn__icon-off"
                      style="padding: 11px 11px;"
                      @click.prevent="onFileDeleteClicked(docNum,index)">
                    </button>
                  </div>
                  <p
                    v-if="getError(docNum,true,index)"
                    class="error-text">
                    {{ getError(docNum,true,index) }}
                  </p>
                  <p
                    v-else-if="Number(pointer[0])===docNum
                      && Number(pointer[1])===index
                      && imageError"
                    class="error-text">
                    {{ imageError }}
                  </p>
                </div>
                <button
                  type="button"
                  class="c-btn c-btn--narrow"
                  style="margin-top:0.5em;"
                  @click.prevent="onFileAddClicked(docNum)">
                  ファイルを追加
                </button>
              </div>
            </div>

            <div
              v-if="doc.type !== typeAiId">
              <div cols="12">
                <div
                  class="checkbox"
                  style="display:block;margin-top:1em;">
                  <label>
                    <input
                      type="checkbox"
                      :checked="doc.showUrls"
                      @click="onClickUrls(docNum)">
                    <div
                      class="option-input">
                    </div>
                    URLを追加
                  </label>
                </div>
              </div>
            </div>
            <div v-if="doc.type !== typeAiId && doc.showUrls">
              <div>
                <div
                  v-for="(current,index) in doc.urls"
                  :key="current.url"
                  class="form-item"
                  style="margin-top:0.5em;">
                  <input
                    v-model.lazy="value[docNum].urls[index].path"
                    class="form-control url-input"
                    type="url" />
                  <button
                    type="button"
                    class="c-btn c-btn--narrow c-btn__icon-off"
                    @click.prevent="onUrlDeleteClicked(docNum,index)">
                  </button>
                  <p
                    v-if="getError(docNum,false,index)"
                    class="error-text">
                    {{ getError(docNum,false,index) }}
                  </p>
                </div>
                <button
                  type="button"
                  class="c-btn c-btn--narrow"
                  style="margin-top:0.5em;"
                  @click.prevent="onUrlAddClicked(docNum)">
                  URLを追加
                </button>
              </div>
            </div>
            <p
              v-if="errors[`rights_documents.${docNum}`]"
              class="error-text">
              {{ errors[`rights_documents.${docNum}`].join('') }}
            </p>

            <button
              v-if="value.length-1===docNum"
              type="button"
              class="c-btn c-btn--narrow pcw-60"
              style="margin-top:1em;"
              @click.prevent="onDocumentAddClicked()">
              権利物の種類を追加する
            </button>
            <button
              v-if="docNum > 0"
              type="button"
              class="c-btn c-btn--delete-large c-btn--narrow"
              style="margin-top: 1em;"
              @click.prevent="onDocumentDeleteClicked(docNum)">
              削除
            </button>
          </div>
          <p
            v-if="errors[`rights_documents`]"
            class="error-text">
            {{ errors[`rights_documents`].join('') }}
          </p>
        </div>
        <input
          ref="rights-input"
          style="display: none;"
          type="file"
          accept=".png,.jpeg,.jpg,.pdf"
          @change="onFileChanged" />
      </div>
    </div>
  </div>
</template>

<script>
import tooltip from '../../../mixins/tooltip'
import tooltipMessages from './track-tooltips'

export default {
  name: 'RightsDocument',
  mixins: [
    tooltip,
  ],
  props: {
    value: {
      type: Array,
      required: true,
    },
    useRights: {
      type: Number,
      required: true,
    },
    errors: {
      type: Object,
      default: null,
    },
    tooltipMessages: {
      type: Object,
      default: () => tooltipMessages,
    },
  },
  data() {
    return {
      types: {},
      rightsTemplate: {
        type: 0,
        images: [],
        urls: [],
      },
      showImages: [],
      showUrls: [],
      pointer: [0, 0],
      rightsFlag: '0',
      imageError: null,
      typeAiId: -1,
    }
  },
  watch: {
    useRights() {
      this.rightsFlag = this.useRights.toString()
    },
    value() {
      this.value.forEach((doc, index) => {
        if (doc.images.length > 0) this.value[index].showImages = true
        if (doc.urls.length > 0) this.value[index].showUrls = true
      })
    },
  },
  mounted() {
    this.fetchTypes()
  },
  methods: {
    async fetchTypes() {
      const { data } = await window.axios.get('/api/client/rightsDocumentsTypes')
      this.types = [{ id: 0, label: '選択してください' }, ...data]
      this.typeAiId = this.types.find((t) => t.label === '生成AIによって制作された音源').id ?? -1
    },
    onFileSelectClicked(e) {
      this.pointer = e.target.classList[0].split('-')
      this.imageError = null
      this.$refs['rights-input'].click()
    },
    selectableTypes(selfTypes) {
      const types   = JSON.parse(JSON.stringify(this.types))
      this.value.forEach(doc => {
        if (doc.type === selfTypes) return
        types.splice(types.findIndex(type => doc.type === type.id), 1)
      })
      return types
    },
    // ファイル選択時コールバック
    onFileChanged(e) {
      const num = this.pointer[0]
      const index = this.pointer[1]
      const files = e.target.files || e.dataTransfer.files
      const reader = new FileReader()
      const { name } = files[0]
      const truncatedName = this.truncate(name)
      const self = this
      if (this.value[num].images.some((i) => i.name === truncatedName)) {
        this.imageError = '同じファイルは追加できません'
        this.$refs['rights-input'].value = null
        return
      }

      reader.onload = () => {
        self.$set(self.value[num].images, index,
          { name: self.truncate(name), file: files[0] })
        self.$refs['rights-input'].value = null
      }
      reader.readAsDataURL(files[0])
    },
    onFileDeleteClicked(num, i) {
      this.value[num].images.splice(i, 1)
    },
    onFileAddClicked(num) {
      this.value[num].images.push({ name: null })
      this.pointer = [num, this.value[num].images.length - 1]
      this.imageError = null
      this.$refs['rights-input'].click()
    },
    onUrlDeleteClicked(num, i) {
      this.value[num].urls.splice(i, 1)
    },
    onUrlAddClicked(num) {
      this.value[num].urls.push({ path: null })
    },
    onDocumentAddClicked() {
      this.value.push(JSON.parse(JSON.stringify(this.rightsTemplate)))
    },
    onDocumentDeleteClicked(num) {
      this.value.splice(num, 1)
    },
    getError(docNum, isFile, index) {
      if (this.value[docNum][isFile ? 'images' : 'urls'][index].id) {
        return false
      }
      let counter = 0
      this.value[docNum][isFile ? 'images' : 'urls'].forEach((file, i) => {
        if (i < index && !file.id) {
          counter += 1
        }
      })
      if (this.errors
        && this.errors[`rights_documents.${docNum}.${isFile ? 'files' : 'urls'}.${counter}`]) {
        return this.errors[`rights_documents.${docNum}.${isFile ? 'files' : 'urls'}.${counter}`][0]
      }
      return false
    },
    truncate(str) {
      const dotSplitedStr = str.split('.')
      const extension = dotSplitedStr[dotSplitedStr.length - 1]
      const name = dotSplitedStr.slice(0, -1).join('.')
      const nameLength =  (name.match(/[^ -~]/g)?.length ?? 0) + name.length
      const limit = 10
      // 20文字以下の場合はまとめ処理をしない
      if (nameLength <= limit * 2) {
        return str
      }
      /* eslint-disable */
      const frontName = name.split('')
        .reduce(
          (acc, c) => ((acc[1] += !c.match(/[ -~]/) + 1) <= limit
            ? [acc[0] + c, acc[1]]
            : [acc[0], limit]),
          ['', 0],
        )[0]

      const endName = name.split('').reverse()
        .reduce(
          (acc, c) => ((acc[1] += !c.match(/[ -~]/) + 1) <= limit
            ? [c + acc[0], acc[1]]
            : [acc[0], limit]),
          ['', 0],
        )[0]
      /* eslint-enable */
      return `${frontName}...${endName}.${extension}`
    },
    onClickImages(num) {
      this.$set(this.value[num], 'showImages', !this.value[num].showImages)
      this.$forceUpdate()
    },
    onClickUrls(num) {
      if (this.value[num].urls.length === 0) {
        this.value[num].urls.push({ path: null })
      }
      this.$set(this.value[num], 'showUrls', !this.value[num].showUrls)
    },
    onRightsFlagChange(event) {
      const flag = event.target.value
      if (flag === '1' && this.value.length === 0) {
        this.value.push(JSON.parse(JSON.stringify(this.rightsTemplate)))
      }
      this.$emit('update-rights-check', Number(flag))
    },
    typeChange(num) {
      if (this.value[num].type === this.typeAiId) {
        this.value[num].urls = []
      }
    },
  },
}
</script>
<style>
.card-top-line {
  margin-top: 1em;
  border-top: 1px solid #dadada;
}

.c-btn__icon-off {
  padding: 11px;
}

.url-input + .c-btn__icon-off {
  right:30px;
}

@media screen and (min-width: 896px) {
  .pcw-60 {
    width:60%;
  }

  .url-input {
    width:60%;
  }

}

@media screen and (max-width: 896px) {
  .spw-90 {
    width:90%;
  }

  .url-input {
    width:100%;
  }

  .c-btn__icon-off {
    width: 7vw;
    height: 7vw;
    right: 0;
  }

  .url-input +.c-btn__icon-off {
    right: 12px;
    top: 8px;
    position: absolute;
  }
}
</style>
